import { Queue, priorities } from '@nx-js/queue-util';
import { observable, observe } from '@nx-js/observer-util';

var scheduler = new Queue(priorities.LOW);

function toPathArray(path) {
  return path.split('/').filter(notEmpty);
}

function toPathString(path) {
  return '/' + path.filter(notEmpty).join('/');
}

function toQuery(params) {
  var queryTokens = [];

  for (var key in params) {
    var value = params[key];
    if (value !== undefined) {
      key = encodeURIComponent(key);
      value = encodeURIComponent(JSON.stringify(value));
      queryTokens.push((key + "=" + value));
    }
  }
  return queryTokens.length ? '?' + queryTokens.join('&') : '';
}

function toParams(queryString) {
  var queryTokens = queryString.slice(1).split('&').filter(notEmpty);

  var params = {};
  for (var i = 0, list = queryTokens; i < list.length; i += 1) {
    var token = list[i];

    var keyValue = token.split('=');
    if (keyValue.length === 2) {
      var key = decodeURIComponent(keyValue[0]);
      var value = decodeURIComponent(keyValue[1]);
      try {
        params[key] = JSON.parse(value);
      } catch (err) {
        params[key] = value;
      }
    }
  }
  return params;
}

function notEmpty(token) {
  return token !== '';
}

var params = observable(toParams(location.search));
var path = observable(toPathArray(location.pathname));

function setParams(newParams) {
  for (var i = 0, list = Object.keys(params); i < list.length; i += 1) {
    var key = list[i];

    delete params[key];
  }
  Object.assign(params, newParams);
}

function setPath(newPath) {
  path.length = 0;
  path.push.apply(path, newPath);
}

function syncUrl() {
  var url = toPathString(path) + toQuery(params) + location.hash;
  history.replaceState(history.state, '', url);
}

observe(syncUrl, { scheduler: scheduler });

var STORAGE_NAME = 'REACT_EASY_STORAGE';
var storage = observable(JSON.parse(localStorage.getItem(STORAGE_NAME)) || {});

function setStorage(newStorage) {
  for (var i = 0, list = Object.keys(storage); i < list.length; i += 1) {
    var key = list[i];

    delete storage[key];
  }
  Object.assign(storage, newStorage);
}

function syncStorage() {
  localStorage.setItem(STORAGE_NAME, JSON.stringify(storage));
}

observe(syncStorage, { scheduler: scheduler });

export { params, path, setParams, setPath, storage, setStorage, scheduler };



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-easy-params/dist/es.es5.js
// module id = 9
// module chunks = 0